import http from "@/http-common"

class EventDataService {
    getAll(url) {
        return http.get(`events${ url }`)
    }

    get(id) {
        return http.get(`events/${ id }`)
    }

    post(data) {
        return http.post('events', data)
    }

    patch(id, data, headers) {
        return http.patch(`events/${ id }`, data, headers)
    }

    delete(id) {
        return http.delete(`events/${ id }`)
    }
}

export default new EventDataService()